<template>
  <b-navbar type="dark" variant="dark">
      <b-navbar-nav>
        <b-nav-item><router-link to="/">Home</router-link></b-nav-item>
      </b-navbar-nav>
    </b-navbar>
</template>

<script>
export default {
  name: 'Header',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a{
    color: white;
    font-size: 1.1rem;
    font-weight: 500;
}

a:hover{
    color: rgb(37, 120, 214)
}

a:link {
  text-decoration: none;
}

a:visited {
  text-decoration: none;
}

</style>